fx.ns("shared.popups", class FileAlreadyProcessing extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 210;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Un fichier est déjà en cours d'import"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Veuillez attendre que le premier fichier soit importé."), className:"text center"}));

        this.addFooterChild("close");
    }

    onClose()
    {
        super.onClose();

        this.data.event("show-editor")
    }
});